import clsx from "clsx";
import { FunctionComponent } from "react";

import { type MetaVariation } from "@ui/components/content-cards/ContentBlock";
import OutboundLinkIcon from "@ui/components/icon/OutboundLinkIcon";
import { metaTextVariant } from "@ui/shared-styles/text.css";

import * as styles from "./ContentBlockCrosspost.css";

interface Props {
  source: string;
  metaVariation?: MetaVariation;
  className?: string;
}

const ContentBlockCrosspost: FunctionComponent<Props> = ({
  source,
  metaVariation = "standard",
  className,
}) => {
  return (
    <span
      className={clsx(
        metaTextVariant[metaVariation],
        styles.container,
        className,
      )}
    >
      From {source}
      <OutboundLinkIcon className={styles.icon} />
    </span>
  );
};

export default ContentBlockCrosspost;
